import React from 'react';
import { Row, Col, Spinner } from 'reactstrap';
import PropertyCard from './PropertyCard';

export default function PropertyList({ properties, loading, sentinelRef, selectedProperties, toggleSelection, onRowClick, activeFilters }) {
  if (!loading && (!properties || properties.length === 0)) {
    return (
      <div className='fp-empty'>
        <p>No properties found. Try adjusting your filters.</p>
      </div>
    );
  }

  return (
    <div>
      <Row className=''>
        {properties.map((property) => (
          <Col xs='12' md='6' xl='4' key={property.id} className='mb-4'>
            <PropertyCard
              property={property}
              selectedProperties={selectedProperties}
              toggleSelection={toggleSelection}
              onRowClick={onRowClick}
              activeFilters={activeFilters}
            />
          </Col>
        ))}
      </Row>

      <div ref={sentinelRef} style={{ height: 1 }} />

      {loading && (
        <div className='text-center py-3'>
          <Spinner size='sm' /> Loading...
        </div>
      )}
    </div>
  );
}
